import React from "react";
import { Query } from "react-apollo";
// import { Select } from "antd";
import { Cache } from "aws-amplify";
import AllOrders from "../../GraphQL/Query/AllOrders";
import OrdersList from "./OrdersList";

// const Option = Select.Option;

class OrdersComponent extends React.Component {
  //   state = {
  //     status: null
  //   };

  //   handleChange = (value, userId, refetch) => {
  //     //console.log(`selected ${value}`);
  //     this.setState({ status: value });
  //     // this.setState({ status: value }, () => {
  //     //   refetch({ userId, limit: this.limit, status: value });
  //     // });
  //   };

  render() {
    const { profile } = this.props;
    const limit = Cache.getItem("limit") || null;
    return (
      <Query
        query={AllOrders}
        variables={{ userId: profile.username, limit: limit }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data, refetch, fetchMore }) => {
          //console.log(error);
          return (
            <React.Fragment>
              {/* <div className="orders-toolbar" style={{ marginBottom: 24 }}>
                Filtrar
                <Select
                  value={this.state.status}
                  style={{ width: 160, marginLeft: 8 }}
                  onChange={value =>
                    this.handleChange(value, profile.username, refetch)
                  }
                >
                  <Option value={null}>Todos</Option>
                  <Option value="created">Creado</Option>
                  <Option value="collectingData">Recopilando Datos</Option>
                  <Option value="validatingData">Validando Datos</Option>
                  <Option value="inProcess">En Proceso</Option>
                  <Option value="sent">Enviado</Option>
                  <Option value="completed">Completado</Option>
                  <Option value="canceled">Cancelado</Option>
                </Select>
              </div> */}
              <OrdersList
                loading={loading}
                error={error}
                data={data}
                onLoadMore={nextToken =>
                  fetchMore({
                    query: AllOrders,
                    variables: {
                      userId: profile.username,
                      limit: this.limit,
                      nextToken
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                      const previousEntry = previousResult.allOrders;
                      const newOrders = fetchMoreResult.allOrders.items;
                      const newToken = fetchMoreResult.allOrders.nextToken;

                      return {
                        allOrders: {
                          nextToken: newToken,
                          items: [...previousEntry.items, ...newOrders],
                          __typename: "PaginatedOrders"
                        }
                      };
                    }
                  })
                }
              />
            </React.Fragment>
          );
        }}
      </Query>
    );
  }
}

export default OrdersComponent;



// WEBPACK FOOTER //
// ./src/Components/Orders/OrdersComponent.js